import React, { useState } from 'react';
import {
  getFieldsDifferenceBetweenTwoObjects,
  mapFieldToReadableText,
} from './utils';
import { Checkbox, Icon, Modal } from 'antd';
import IFrame from 'components/blocks/IFrame';
import {
  useGetAllCategories,
  useGetAllEmailTypes,
} from '../../../../query/mail';

type Props = {
  prev: Object,
  current: Object,
};

function RenderField({ field, value }) {
  const { data: emailTypes } = useGetAllEmailTypes();
  const { data: categories } = useGetAllCategories();
  switch (field) {
    case 'isAmp':
      return <Checkbox checked={Boolean(value)}>Is AMP Template?</Checkbox>;
    case 'ampReplaceMagicLink':
      return (
        <Checkbox checked={Boolean(value)}>AMP Replace Magic Link</Checkbox>
      );
    case 'bypassUnsubscription':
      return (
        <Checkbox checked={Boolean(value)}>Bypass unsubscription</Checkbox>
      );
    case 'isRateLimitExcluded':
      return <Checkbox checked={Boolean(value)}>Relaxed Throttling</Checkbox>;
    case 'ampTemplate':
    case 'template':
      return (
        <div
          className="w-full"
          style={{ maxHeight: 500, border: '1px solid #ccc' }}
        >
          <IFrame html={value} />
        </div>
      );
    case 'textTemplate':
      if (!value) return 'None';
      return (
        <div
          className="w-full"
          style={{
            maxHeight: 500,
            border: '1px solid #ccc',
            overflow: 'auto',
          }}
        >
          {value}
        </div>
      );
    case 'forceChoose':
      return value || 'Automatic Load Balancer';
    case 'categoryId':
      return categories.find(e => e.id === value)?.name || 'None';
    case 'emailTypeId':
      return emailTypes.find(e => e.id === value)?.type || 'None';
    default:
      return value;
  }
}

function RenderFieldDiff({ fieldDiff }) {
  return (
    <div className="w-full space-y-2" key={fieldDiff.key}>
      <div style={{ fontFamily: 'GorditaMedium' }}>{fieldDiff.title}</div>
      <div className="flex items-center w-full space-x-2">
        <div className="flex-1 flex">
          <RenderField field={fieldDiff.key} value={fieldDiff.prev} />
        </div>
        <div>
          <Icon type="arrow-right" />
        </div>
        <div className="flex-1 flex">
          <RenderField field={fieldDiff.key} value={fieldDiff.current} />
        </div>
      </div>
    </div>
  );
}

export default function ViewChangeDetailButton(props: Props) {
  const fieldsDiff = getFieldsDifferenceBetweenTwoObjects(
    props.prev,
    props.current,
  );
  const renderableFields = fieldsDiff
    .map(e => ({
      key: e,
      title: mapFieldToReadableText[e],
      prev: props.prev[e],
      current: props.current[e],
    }))
    .filter(e => e.title);
  const [visible, setVisible] = useState(false);
  return (
    <>
      <Icon
        style={{ color: '#42A5F5', cursor: 'pointer' }}
        type="eye"
        onClick={() => setVisible(true)}
      />
      <Modal
        title="Change Details"
        visible={visible}
        width={1000}
        onCancel={() => setVisible(false)}
      >
        <div className="space-y-4 w-full">
          {renderableFields.map(e => (
            <RenderFieldDiff fieldDiff={e} key={e.key} />
          ))}
        </div>
      </Modal>
    </>
  );
}
